class CostCenter {
  constructor(
    formElementGuid,
    formElementName,
    prefilledCostCenter,
    singleEmployeePickerSelector = null,
    multiEmployeePickerSelector = null,
    clearEmployeeWarningLabel = null
  ) {
    this.formElementGuid = formElementGuid;
    this.formElementName = formElementName;
    this.prefilledCostCenter = prefilledCostCenter;
    this.singleEmployeePickerSelector = singleEmployeePickerSelector;
    this.multiEmployeePickerSelector = multiEmployeePickerSelector;
    this.clearEmployeeWarningLabel = clearEmployeeWarningLabel;
  }
  load(){
    const waitForPickersReady = () => {
      let readyCount = 0;
      const needed = [this.singleEmployeePickerSelector, this.multiEmployeePickerSelector].filter(Boolean).length;
      const onReady = (p) => {
        readyCount++;
        if (readyCount === needed) {
          this.populateChildSelectors(this.prefilledCostCenter, true);
        }
      };
      [this.singleEmployeePickerSelector, this.multiEmployeePickerSelector].forEach(selector => {
        if (selector) {
          const picker = document.querySelector(selector);
          if (picker != null){
            if (picker.dataset.loaded === "true") {
              // Picker is already ready, call handler immediately
              onReady(picker);
            } else {
              // Wait for picker to become ready
              picker.addEventListener('EmployeePickerReady', () => onReady(picker), { once: true });
            }
          }
        }
      });
    };

    if (this.prefilledCostCenter && !!this.prefilledCostCenter?.trim()) {
      waitForPickersReady();
    }
    this.valueInput = document.getElementById(this.formElementGuid);
    let lastValue = this.valueInput.value;
    this.valueInput.addEventListener("change", (e) => {
      if (e.target.value !== lastValue) {
        this.populateChildSelectors(e.target.value);
        lastValue = e.target.value;
      } 
      else{
        this.setLoadingStateOnChildSelectors(false);
      }
    });
    this.valueInput.addEventListener("focus", (e) => {
      this.setLoadingStateOnChildSelectors(true);
    });
  }
  
  setLoadingStateOnChildSelectors(state){
    if (this.singleEmployeePickerSelector != null) {
      this.setLoadingStateOnChildSelector(this.singleEmployeePickerSelector, state);
    }
    if (this.multiEmployeePickerSelector != null) {
      this.setLoadingStateOnChildSelector(this.multiEmployeePickerSelector, state);
    }
  }
  populateChildSelectors(costCenter, initialLoad = false){
    if (this.singleEmployeePickerSelector != null) {
      this.populateChildSelector(this.singleEmployeePickerSelector, costCenter, initialLoad);
    }
    if (this.multiEmployeePickerSelector != null) {
      this.populateChildSelector(this.multiEmployeePickerSelector, costCenter, initialLoad);
    }
  }
  setLoadingStateOnChildSelector(selector, state) {
    const picker = document.querySelector(selector);
    if (picker == null) return;

    const loadingEvent = new CustomEvent('OnLoadingStateChanged', {
      detail: {
        loading: state
      }
    });
    picker.dispatchEvent(loadingEvent);
  }
  populateChildSelector(selector, costCenter, initialLoad = false) {
    const picker = document.querySelector(selector);
    if (picker == null) return;
    
    const repopulationEvent = new CustomEvent('OnRepopulation', {
      detail: {
        costcenter: costCenter,
        initialLoad: initialLoad
      }
    });
    if(initialLoad === true) {
        picker.dispatchEvent(repopulationEvent);
    }
    else{
      const checkSelectionEvent = new CustomEvent('OnCheckSelection', {
        bubbles: true,
        cancelable: true,
        detail: {
          hasSelection: false
        }
      });
      picker.dispatchEvent(checkSelectionEvent);
      if (checkSelectionEvent.detail.hasSelection == true) {
        if (confirm(this.clearEmployeeWarningLabel) == true) {
          picker.dispatchEvent(repopulationEvent);
        }
      }
      else {
        picker.dispatchEvent(repopulationEvent);
      }
    }
    
  }
}

window.FalckComponents = {
  ...window.FalckComponents,
  CostCenter: CostCenter
};
